import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { v4 } from 'uuid';
import {
  ErrorHandlerService,
  LocalizationService,
  LoggerService,
  supportUrlsLocalized,
  URLS,
} from 'i2g-ng-utils';
import { Observable, Subject } from 'rxjs';
import { BannerComponent } from './banner.component';
import {
  BannerActionsEnum,
  BannerTypesEnum,
  IBanner,
  IBannerTrigger,
} from './banner.data';

@Injectable({
  providedIn: 'root',
})
export class BannerService {
  private _bannerTriggers: Subject<IBannerTrigger> = new Subject<IBannerTrigger>();

  bannerTriggers$: Observable<IBannerTrigger> = this._bannerTriggers.asObservable();

  constructor(
    private _loggerService: LoggerService,
    private _translateService: TranslateService,
    private _localizationService: LocalizationService,
    private _errorHandlerService: ErrorHandlerService
  ) {}

  showBanner(type: BannerTypesEnum, data: IBanner) {
    const defaultBanner: IBanner = {
      id: v4(),
      dismissible: true,
      onDismiss: () => this.hideBanner(type),
    };
    const banner = {
      ...defaultBanner,
      ...data,
    };

    this._loggerService.log('displaying banner:', banner);
    this._bannerTriggers.next({
      type,
      action: BannerActionsEnum.show,
      banner,
    });
  }

  hideBanner(type: BannerTypesEnum) {
    this._bannerTriggers.next({
      type,
      action: BannerActionsEnum.hide,
    });
  }

  showSystemErrorBanner(
    error: Error,
    messageHtml?: string,
    onDismiss?: (bannerId: string, component: BannerComponent) => void
  ) {
    this._errorHandlerService.alertSystem(error);

    return this.showBanner(BannerTypesEnum.error, {
      message:
        messageHtml ||
        this._translateService.instant('ERROR.SERVER_ERROR', {
          url: supportUrlsLocalized(
            URLS.SUPPORT,
            this._localizationService.getCurrentLocale()
          ),
        }),
      containsHtml: true,
      dismissible: true,
      isSticky: true,
      onDismiss,
    });
  }
}
